import { OrderProject, OrderProjectToken } from "$src/application/projects/commands/OrderProject";
import { ProjectIdentifier } from "$src/domain/projects/ProjectIdentifier";
import { useMutation, useQueryClient } from "@sveltestack/svelte-query";
import { container } from "tsyringe";

export async function orderProject(groupStoreId: number, projectId: number)
    : Promise<ProjectIdentifier> {

    const query = container.resolve<OrderProject>(OrderProjectToken);
    return query.execute(groupStoreId, projectId);
}

export function useOrderProject() {
    const queryClient = useQueryClient();

    return useMutation(
        ({ groupStoreId, projectId}: 
            { groupStoreId: number, projectId: number }
        ) => orderProject(groupStoreId, projectId),
        {
            onSuccess: (data, variables) => {
                //queryClient.invalidateQueries(['folders', variables.data.customerId]);
            },
            onError: (error: Error) => {
                console.error('Failed to ordering project:', error);
            },
            onSettled: () => {
            },
        }
    );
}